let config: Record<string, any> = {}

export async function loadConfig() {
  const response = await fetch('/config.json')
  config = await response.json()
}

export function getConfig(key: string) {
  return config[key]
}
